import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { workOrderNewService } from '../services/workOrderNew.service';
import type { WorkOrderNewFormValues } from '../types/workOrderNew.types';

export function useWorkOrderNew(companyId: string) {
  const queryClient = useQueryClient();

  const { data: referenceData, isLoading: isLoadingOptions } = useQuery({
    queryKey: ['work-order-reference-data', companyId],
    queryFn: () => workOrderNewService.getReferenceData(companyId),
    enabled: !!companyId,
  });

  const createMutation = useMutation({
    mutationFn: ({ userId, values }: { userId: string; values: WorkOrderNewFormValues }) =>
      workOrderNewService.createWorkOrder(companyId, userId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['work-orders'] });
    },
  });

  return {
    referenceData,
    isLoadingOptions,
    createWorkOrder: createMutation.mutateAsync,
    isSaving: createMutation.isPending,
  };
}
